//Higher Order Component to wrap other components in main classes, instead of an extra div
const aux = (props) => props.children;

export default aux;